'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _QueryNodeVisitor2 = require('./QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BinderIndexingMetadataVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(BinderIndexingMetadataVisitor, _QueryNodeVisitor);

    function BinderIndexingMetadataVisitor(rootNode) {
        (0, _classCallCheck3.default)(this, BinderIndexingMetadataVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BinderIndexingMetadataVisitor.__proto__ || (0, _getPrototypeOf2.default)(BinderIndexingMetadataVisitor)).call(this));

        _this.queryNode = rootNode;
        _this.indexingMetadata = {
            descriptorValues: {},
            defaultValues: {},
            singleValueDescriptorValues: {}
        };
        return _this;
    }

    (0, _createClass3.default)(BinderIndexingMetadataVisitor, [{
        key: 'visitDataSourceSingleValue',
        value: function visitDataSourceSingleValue(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var value = context.currentValueSet.value;

            this.addDescriptorValues(descriptorId, value, true);
        }
    }, {
        key: 'visitScalarValue',
        value: function visitScalarValue(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var value = context.currentValueSet.value;

            this.addDescriptorValues(descriptorId, value, false);
        }
    }, {
        key: 'visitFixedValue',
        value: function visitFixedValue(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var value = context.currentValueSet.value;

            this.addDescriptorValues(descriptorId, value, false);
        }
    }, {
        key: 'visitSelectList',
        value: function visitSelectList(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var value = context.currentValueSet.selected;

            this.addDescriptorValues(descriptorId, value, false);
        }
    }, {
        key: 'visitMultiselectList',
        value: function visitMultiselectList(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var values = context.currentValueSet.selectedValues;

            this.addDescriptorValues(descriptorId, values, false);
        }
    }, {
        key: 'visitDataSourceMultipleValue',
        value: function visitDataSourceMultipleValue(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var values = context.currentValueSet.selectedValues;

            this.addDescriptorValues(descriptorId, values, false);
        }
    }, {
        key: 'visitValueList',
        value: function visitValueList(context) {
            if (!BinderIndexingMetadataVisitor.isOnNonDateDescriptorPredicateNode(context)) {
                return;
            }
            var descriptorId = context.currentNode.descriptorId;
            var values = context.currentValueSet.values;

            this.addDescriptorValues(descriptorId, values, false);
        }

        /**
         * Adds values to the list that are in use by one or more descriptors
         * @param {string} descriptorId
         * @param {any|Array<any>} values
         */

    }, {
        key: 'addDescriptorValues',
        value: function addDescriptorValues(descriptorId, values, isSingleValueDescriptorValue) {
            var _indexingMetadata = this.indexingMetadata,
                descriptorValues = _indexingMetadata.descriptorValues,
                defaultValues = _indexingMetadata.defaultValues,
                singleValueDescriptorValues = _indexingMetadata.singleValueDescriptorValues;

            values = _lodash2.default.castArray(values);
            if (!_lodash2.default.has(descriptorValues, descriptorId)) {
                descriptorValues[descriptorId] = [];
            }
            descriptorValues[descriptorId] = _lodash2.default.union(descriptorValues[descriptorId], values);
            if (descriptorValues[descriptorId].length === 1 && !_lodash2.default.has(defaultValues, descriptorId)) {
                defaultValues[descriptorId] = _lodash2.default.head(descriptorValues[descriptorId]);
                singleValueDescriptorValues[descriptorId] = isSingleValueDescriptorValue ? _lodash2.default.head(descriptorValues[descriptorId]) : null;
            }
            if (descriptorValues[descriptorId].length > 1 && _lodash2.default.has(defaultValues, descriptorId)) {
                _lodash2.default.unset(defaultValues, descriptorId);
            }
        }
    }], [{
        key: 'isOnNonDateDescriptorPredicateNode',
        value: function isOnNonDateDescriptorPredicateNode(context) {
            return context.currentNode.type === 'DescriptorPredicate' && !['DATEONLY', 'DATETIME'].includes(context.currentNode.descriptor.dataType.toUpperCase());
        }
    }]);
    return BinderIndexingMetadataVisitor;
}(_QueryNodeVisitor3.default);

exports.default = BinderIndexingMetadataVisitor;